import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import {IoClose} from 'react-icons/io5';
import { myId } from "../../../../lib/MyLibrary";

const terminosMasBuscados = [
  "peluche",
  "taza",
  "organizador",
  "bolsas",
  "sanrio",
  "audifonos",
  "we bear bears",
  "mochila",
  "llavero",
  "marvel",
];

const MySearchDropDown = ({handleDropDown,showMyDropDown}) => {
  const [targetURL, setTargetURL] = useState("#");
 

  const handleLink = (e) => {
    const baseURL = "https://www.miniso.com.mx/";
    let data = e.target.name;
    if (data===undefined) data=e.target.attributes.name.value;
    const temp = `${baseURL}${data}?_q=${data}&map=ft`;
     
     setTargetURL(temp);
  };
  
  return (
    <Dropdown show={showMyDropDown}>
      <Dropdown.Menu style={{zIndex:'10000'}} className="w-100">
        <div className="d-flex align-items-center justify-content-between p-2">
        <h6 className="fs-6">TÉRMINOS MÁS BUSCADOS</h6>
        <IoClose style={{cursor:'pointer'}} onClick={handleDropDown} className="fs-5"/>
        </div>
        {terminosMasBuscados.map((item, i) => {
          return (
            <Dropdown.Item
              key={myId()}
              name={`${item}`}
              onMouseOver={handleLink}
              href={targetURL}
              className='w-100'
            >
              <div name={`${item}`}  className="d-flex">
                <p name={`${item}`} className="text-secondary mx-2 fw-bold opacity-50">{`${
                  i + 1
                }.`}</p>
                <p name={`${item}`} className="ms-2">{item}</p>
              </div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MySearchDropDown;
